import { createFileRoute } from "@tanstack/react-router";
import { requerirEdicionDeSolicitud } from "@/features/solicitudes/utils/guard-edicion";
import { ProveedorManualPage } from "@/features/proveedor-manual/components/ProveedorManualPage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert, WizardPasoSkeleton } from "@/components/ui";

/**
 * Ruta `/solicitudes/$id/proveedor-manual` · P44 FB60 Contrapago.
 */
export const Route = createFileRoute("/_authed-tw/solicitudes/$id/proveedor-manual")({
  beforeLoad: requerirEdicionDeSolicitud,
  loader: ({ context: { queryClient }, params: { id } }) => queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: ProveedorManualPage,
  pendingComponent: WizardPasoSkeleton,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
